import { ModelBase, observable } from "@shoothill/core";
import { action } from "mobx";
import { RDDV2FormFileModel } from "../../Forms/Common/RDDV2FormFileModel";
export class RDDV2FileModel extends ModelBase<RDDV2FileModel> {
    public static readonly DEFAULT_RDDV2_ID = "";

    @observable
    public rddV2Id: string = RDDV2FileModel.DEFAULT_RDDV2_ID;

    @observable
    public rddV2Files: RDDV2FormFileModel[] = [];

    @action
    public fromDto(dto: RDDV2FileResponseDTO): void {
        for (let key in dto) {
            if (dto.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(dto[key]);
                } else if (key === "rddV2Items") {
                    // Do nothing.
                } else {
                    this[key] = dto[key];
                }
            }
        }
    }

    @action
    toDto(model: RDDV2FileModel): void {}
}

export interface RDDV2FileResponseDTO {
    rddV2Files: RDDV2FormFileModel[];
}

export interface RDDV2FileRequestDTO {
    id: string | null;
}
